export type DashboardInvoiceStatusView = 'paid' | 'sent';
export type DashboardQuoteStatusFilter = 'all' | 'accepted' | 'rejected' | 'cash';
export type DashboardVatFilterType = 'input' | 'output';

export function buildDashboardRangeQuery(args: { from: Date; to: Date; period: string }): string {
  const { from, to, period } = args;
  return `from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}&period=${encodeURIComponent(period)}`;
}

export function buildDocsInvoiceFilterPath(rangeQuery: string, statusView: DashboardInvoiceStatusView): string {
  const statusParam = statusView === 'paid' ? 'paid' : 'unpaid';
  return `/docs?kind=Invoice&status=${statusParam}&${rangeQuery}`;
}

export function buildDocsQuoteEstimateFilterPath(rangeQuery: string): string {
  return `/docs?kind=quote_estimate&status=all&invoice_state=not_invoiced&${rangeQuery}`;
}

export function buildDocsQuoteEstimateStatusFilterPath(
  rangeQuery: string,
  status: DashboardQuoteStatusFilter
): string {
  return `/docs?kind=quote_estimate&status=${status}&${rangeQuery}`;
}

export function buildDocsQuoteEstimateAwaitingFilterPath(rangeQuery: string): string {
  return `/docs?kind=quote_estimate&status=all&pipeline_state=awaiting_final&${rangeQuery}`;
}

export function buildDocsVatFilterPath(rangeQuery: string, type: DashboardVatFilterType): string {
  const inputVatSelected = type === 'input' ? '&input_vat_selected=true' : '';
  return `/docs?kind=Invoice&status=paid${inputVatSelected}&${rangeQuery}`;
}

export function buildFenestrationDrilldownPath(rangeQuery: string, metric: string): string {
  return `/fenestration?metric=${encodeURIComponent(metric)}&${rangeQuery}`;
}

export function buildAdditionalCostsDrilldownPath(
  rangeQuery: string,
  args: { mode: 'estimated' | 'accepted'; type: string }
): string {
  const mode = encodeURIComponent(args.mode);
  const type = encodeURIComponent(args.type || 'all');
  return `/dashboard/additional-costs?mode=${mode}&type=${type}&${rangeQuery}`;
}

export function buildProjectsFilterPath(
  rangeQuery: string,
  params: Record<string, string | number | boolean | null | undefined>
): string {
  const pairs = Object.entries(params)
    .filter(([, value]) => value != null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  return `/projects?${pairs.length ? `${pairs.join('&')}&` : ''}${rangeQuery}`;
}
